import noop from 'lodash/noop';
import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

export interface SizingPageModalContext {
  readonly or3SizeGuideVisible: boolean;
  readonly or3VideoVisible: boolean;
  readonly or4SizeGuideVisible: boolean;
  readonly or4VideoVisible: boolean;
  readonly ringModelsVisible: boolean;
  readonly setOr3SizeGuideVisible: Dispatch<SetStateAction<boolean>>;
  readonly setOr3VideoVisible: Dispatch<SetStateAction<boolean>>;
  readonly setOr4SizeGuideVisible: Dispatch<SetStateAction<boolean>>;
  readonly setOr4VideoVisible: Dispatch<SetStateAction<boolean>>;
  readonly setRingModelsVisible: Dispatch<SetStateAction<boolean>>;
}

const Context = createContext<SizingPageModalContext>({
  or3SizeGuideVisible: false,
  or3VideoVisible: false,
  or4SizeGuideVisible: false,
  or4VideoVisible: false,
  ringModelsVisible: false,
  setOr3SizeGuideVisible: noop,
  setOr3VideoVisible: noop,
  setOr4SizeGuideVisible: noop,
  setOr4VideoVisible: noop,
  setRingModelsVisible: noop,
});

export const useSizingPageModalContext = () => {
  return useContext(Context);
};

const SizingPageModalProvider = ({ children }: PropsWithChildren) => {
  const [or3SizeGuideVisible, setOr3SizeGuideVisible] =
    useState<boolean>(false);
  const [or3VideoVisible, setOr3VideoVisible] = useState<boolean>(false);
  const [or4SizeGuideVisible, setOr4SizeGuideVisible] =
    useState<boolean>(false);
  const [or4VideoVisible, setOr4VideoVisible] = useState<boolean>(false);
  const [ringModelsVisible, setRingModelsVisible] = useState<boolean>(false);

  const value = useMemo(() => {
    return {
      or3SizeGuideVisible,
      or3VideoVisible,
      or4SizeGuideVisible,
      or4VideoVisible,
      ringModelsVisible,
      setOr3SizeGuideVisible,
      setOr3VideoVisible,
      setOr4SizeGuideVisible,
      setOr4VideoVisible,
      setRingModelsVisible,
    };
  }, [
    or3SizeGuideVisible,
    or3VideoVisible,
    or4SizeGuideVisible,
    or4VideoVisible,
    ringModelsVisible,
    setOr3SizeGuideVisible,
    setOr3VideoVisible,
    setOr4SizeGuideVisible,
    setOr4VideoVisible,
    setRingModelsVisible,
  ]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default SizingPageModalProvider;
